module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view--basic"
  }, [_vm._v("\n    This displays some content for the view with key \"info\". (" + _vm._s(_vm.tools.currentView.title) + ")\n    "), (_vm.tools.currentView.data.hasPane) ? _c('div', [_vm._v("Has pane!")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.tools.randomizer.first()) + "\n    " + _vm._s(_vm.tools.randomizer.last()) + "\n\n    "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView(); }
    }
  }, [_vm._v("Add breadcrumb")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView({
        key: 'info',
        title: ("Item #" + (Math.floor(Math.random() * 100))),
        data: {
          hasPane: true,
        }
      }); }
    }
  }, [_vm._v("Add item with pane")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView({
        key: 'basic-view',
        title: this$1.tools.randomizer.first(),
        data: {
          hasPane: false,
        }
      }); }
    }
  }, [_vm._v("Add item without pane")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97eba836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BasicView.vue
// module id = 461
// module chunks = 1